import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS } from "@/data/content";
import { SOLUTION_DETAILS } from "@/data/solutions";
import { Icon } from "./Icon";

export const SolutionMiniCard = ({ slug }) => {
  const s = SOLUTIONS.find((x) => x.slug === slug);
  const d = SOLUTION_DETAILS[slug];
  if (!s) return null;
  return (
    <Link to={`/solutions/${slug}`} data-testid={`related-solution-${slug}`} className="card group flex items-start gap-4 p-5">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-line bg-navy text-cyan-400"><Icon name={s.icon} className="h-5 w-5" /></span>
      <div className="min-w-0">
        <div className="font-heading font-semibold text-white">{s.title}</div>
        <p className="mt-1 line-clamp-2 text-sm text-slate-400">{s.tagline}</p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-cyan-400">{d?.formValue} <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" /></span>
      </div>
    </Link>
  );
};
